import type { RouteRecordRaw } from 'vue-router';
import { Urls } from '@/config/Urls';


export const battlesRoutes: RouteRecordRaw[] = [
  // ── Feed (main route after login) ─────────────────────────
  {
    path: Urls.FEED,
    name: 'battlesFeed',
    component: () => import('./pages/BattlesFeed/BattlesFeed.vue'),
    meta: { requiresAuth: true },
  },

  // ── List ──────────────────────────────────────────────────
  {
    path: Urls.BATTLES,
    name: 'battles',
    component: () => import('./pages/BattlesList/Battles.vue'),
    meta: { requiresAuth: true },
  },

  // ── Add ───────────────────────────────────────────────────
  {
    path: Urls.BATTLES_ADD,
    name: 'addBattle',
    component: () => import('./pages/BattleAdd/AddNewBattle.vue'),
    meta: { requiresAuth: true },
  },

  // ── Edit (still uses numeric id – internal only) ──────────
  {
    path: `${Urls.BATTLES_EDIT}/:id`,
    name: 'editBattle',
    component: () => import('./pages/BattleAdd/AddNewBattle.vue'),
    meta: { requiresAuth: true },
  },

  // ── Detail: Judge Panel ───────────────────────────────────
  {
    path: `${Urls.BATTLES_JUDGE_PANEL}/:uuid`,
    name: 'battleJudgePanel',
    component: () => import('./pages/BattleDetail/BattleJudgePanel.vue'),
    meta: { requiresAuth: true },
  },

  // ── Detail: Verdicts ──────────────────────────────────────
  {
    path: `${Urls.BATTLES_VERDICTS}/:uuid`,
    redirect: (to) => `${Urls.BATTLES_VERDICTS}/${to.params.uuid}/verdicts`,
  },
  {
    path: `${Urls.BATTLES_VERDICTS}/:uuid/verdicts`,
    name: 'battleVerdicts',
    component: () => import('./pages/BattleVerdicts/BattleVerdicts.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: `${Urls.BATTLES_VERDICTS}/:uuid/statistics`,
    name: 'battleVerdictsStatistics',
    component: () => import('./pages/BattleVerdicts/BattleVerdicts.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: `${Urls.BATTLES_VERDICTS}/:uuid/my-verdict`,
    name: 'battleVerdictsMyVerdict',
    component: () => import('./pages/BattleVerdicts/BattleVerdicts.vue'),
    meta: { requiresAuth: true },
  },

  // ── Detail: Highlights ────────────────────────────────────
  {
    path: `${Urls.BATTLES_HIGHLIGHTS}/:uuid`,
    name: 'battleHighlights',
    component: () => import('./pages/BattleDetail/BattleHighlights.vue'),
    meta: { requiresAuth: true },
  },

  // ── Detail: Comments (video segment comments) ──────────────
  {
    path: `${Urls.BATTLES_COMMENTS}/:uuid`,
    name: 'battleComments',
    component: () => import('./pages/BattleDetail/BattleComments.vue'),
    meta: { requiresAuth: true },
  },

  // ── Legacy redirects ──────────────────────────────────────
  {
    path: '/battle',
    redirect: Urls.BATTLES_ADD,
  },
  {
    path: '/battle/create',
    redirect: Urls.BATTLES_ADD,
  },
  {
    path: '/add-new-battle',
    redirect: Urls.BATTLES_ADD,
  },
  {
    path: '/battle/edit/:id',
    redirect: (to) => `${Urls.BATTLES_EDIT}/${to.params.id}`,
  },
];
